import React, { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "../../lib/api";
import { useLang } from "../../i18n";
import { PhaseIntro, AddInput, AiButton, ReclusterButton, RevisitCallout } from "../../components/phase-common";
import DragBoard from "../../components/DragBoard";

export default function Phase2({ org, refresh, isAdmin }) {
  const { t, lang } = useLang();
  const [busy, setBusy] = useState(false);
  const [reBusy, setReBusy] = useState(false);
  const remaining = 3 - (org.ai_counts?.touchpoints || 0);
  const items = org.touchpoints || [];

  const add = async (text) => {
    try {
      await api.post("/org/touchpoints", { text, cluster: lang === "nl" ? "Nieuw" : "New" });
      refresh();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const move = async (id, cluster) => {
    await api.patch(`/org/touchpoints/${id}`, { cluster });
    refresh();
  };
  const del = async (id) => {
    try { await api.delete(`/org/touchpoints/${id}`); refresh(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const suggest = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ai/suggest/touchpoints", { lang });
      for (const s of data.suggestions) {
        await api.post("/org/touchpoints", { text: s.text, cluster: s.cluster || "AI" });
      }
      toast.success(`${data.suggestions.length} ${lang === "nl" ? "suggesties toegevoegd" : "suggestions added"}`);
      refresh();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    setBusy(false);
  };
  const recluster = async () => {
    setReBusy(true);
    try { await api.post("/ai/recluster/touchpoints", { lang }); refresh(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    setReBusy(false);
  };

  return (
    <div className="space-y-6">
      <PhaseIntro phase={2} title={t("p2_title")} intro={t("p2_intro")} />
      <RevisitCallout coreEmotion={org.core_emotion} subject={t("p2_subject")} />
      <div className="rounded-2xl border border-border bg-card p-5 space-y-4">
        <AddInput testId="p2-input" label={t("add")}
          placeholder={lang === "nl" ? "Bijv. website, offerte, receptie…" : "E.g. website, quote, reception…"}
          onAdd={add} />
        <div className="flex flex-wrap items-center gap-2">
          <AiButton testId="p2-ai" onClick={suggest} remaining={remaining} busy={busy} label={t("ai_suggest")} />
          {items.length > 1 && <ReclusterButton testId="p2-recluster" onClick={recluster} busy={reBusy} label={t("ai_recluster")} />}
        </div>
      </div>
      <DragBoard items={items} onMove={move} onDelete={del} canDelete={isAdmin} />
    </div>
  );
}
